import React, { useState } from 'react'
import { Panel, Table } from 'rsuite'
import ViewButton from '../../components/buttons/viewButton/ViewButton'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import pathname from '../../constants/pathname'

export default function CenterChangeFormHistoryWidget({ schema, ...props }) {
  const { Column, HeaderCell, Cell } = Table

  const history = useHistory()

  return (
    <>
      <Panel shaded header={schema?.header} collapsible defaultExpanded>
        <Table
          height={400}
          autoHeight={schema?.value?.length <= 5}
          wordWrap
          bordered
          data={schema?.value || []}
          style={{ marginBottom: 10 }}
        >
          <Column width={95} align="center">
            <HeaderCell>ลำดับ</HeaderCell>
            <Cell>
              {(_, index) => {
                return index + 1
              }}
            </Cell>
          </Column>

          <Column width={200} align="center">
            <HeaderCell>ข้อแก้ไขสัญญาครั้งที่</HeaderCell>
            <Cell dataKey="seqNo" />
          </Column>

          <Column width={150} align="center">
            <HeaderCell>เลขที่สัญญา</HeaderCell>
            <Cell dataKey="contractNo" />
          </Column>
          <Column width={200} align="center">
            <HeaderCell>วันที่อนุมัติแก้ไขสัญญา</HeaderCell>
            <Cell dataKey="approveDate" />
          </Column>
          <Column width={150} align="center">
            <HeaderCell>ประเภทการลงนาม</HeaderCell>
            <Cell dataKey="singType" />
          </Column>
          <Column width={380} flexGrow={1}>
            <HeaderCell>สถานะบันทึกแก้ไขเพิ่มเติมข้อตกลง</HeaderCell>
            <Cell dataKey="formStatus" />
          </Column>

          <Column width={150} align="center" fixed="right">
            <HeaderCell></HeaderCell>
            <Cell>
              {(rowData, index) => {
                return (
                  <ViewButton
                    onClick={() => {
                      sessionStorage.setItem('contract_change_id', rowData.id)
                      history.push(pathname.proposal.contract.contractChangeForm)
                    }}
                  />
                )
              }}
            </Cell>
          </Column>
        </Table>
      </Panel>
    </>
  )
}
